import { render } from "./Profile.vue?vue&type=template&id=017ef34a&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=017ef34a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-017ef34a"

export default script